import styled from 'styled-components';
import { theme } from '../../../global';

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 840px;
  flex-direction: column;
  margin: auto;
  gap: ${theme.spacings.s32};
  padding: ${theme.spacings.s40} 0;
`;
